import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { User } from '@sdk/users/types/User';

import type { TimesheetsDashboardNotification } from '@web/timesheets/types/TimesheetsDashboardNotification';
import { DashboardNotificationType } from '@web/dashboard/types';
import TimesheetViewModal from '@web/timesheets/TimesheetViewModal/TimesheetViewModal';
import type { TimesheetViewModalBanner } from '@web/timesheets/TimesheetViewModal/timesheetViewModal.types';
import EmployeePendingConsentTimesheetViewModal from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/EmployeePendingConsentTimesheetViewModal';

type Props = {
  notification: TimesheetsDashboardNotification;
  isVisible: boolean;
  close: () => void;
};

export const TimesheetNotificationModal = ({ notification, isVisible, close }: Props) => {
  const { personasDict } = usePersonaCollection();

  if (
    [
      DashboardNotificationType.timesheetCreatePendingConsent,
      DashboardNotificationType.timesheetEditPendingConsent,
      DashboardNotificationType.timesheetDeletePendingConsent,
    ].includes(notification.type)
  ) {
    return (
      <EmployeePendingConsentTimesheetViewModal
        shift={notification.items[0]}
        isTimesheetPreviewActive={isVisible}
        onClose={close}
        onApprove={close}
        onDeny={close}
      />
    );
  }

  let banner: TimesheetViewModalBanner = null;
  if (notification.type === DashboardNotificationType.timesheetDeletedBySomeone) {
    banner = {
      text: gettext('%(fullname)s deleted your timesheet.', {
        fullname:
          (personasDict[notification.actor.id] as User)?.fullname ||
          notification.actor.fullname ||
          '[unknown]',
      }),
      theme: ThemeColorType.iconGray,
    };
  }

  return (
    <TimesheetViewModal
      isTimesheetPreviewActive={isVisible}
      shift={notification.items[0]}
      onClose={close}
      onTimesheetSave={close}
      banner={banner}
    />
  );
};
